import React from 'react';
import { PageHeader } from '../components/shared/PageHeader';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { Badge } from '../components/ui/badge';
import { Switch } from '../components/ui/switch';
import { useAppContext } from '../lib/store';
import { Avatar, AvatarFallback } from '../components/ui/avatar';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Role } from '../lib/types';
export function UserListPage() {
  const {
    users,
    updateUser,
    auth
  } = useAppContext();
  const handleRoleChange = (userId: string, role: Role) => {
    updateUser(userId, {
      role
    });
  };
  const handleStatusChange = (userId: string, is_active: boolean) => {
    updateUser(userId, {
      is_active
    });
  };
  return <div className="space-y-6" data-id="element-385">
      <PageHeader title="Uporabniki" description="Upravljanje z uporabniki in njihovimi pravicami." data-id="element-386" />

      <div className="bg-white border rounded-lg overflow-hidden" data-id="element-387">
        <Table data-id="element-388">
          <TableHeader data-id="element-389">
            <TableRow data-id="element-390">
              <TableHead data-id="element-391">Uporabnik</TableHead>
              <TableHead data-id="element-392">E-pošta</TableHead>
              <TableHead data-id="element-393">Vloga</TableHead>
              <TableHead data-id="element-394">SSO Ponudnik</TableHead>
              <TableHead data-id="element-395">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody data-id="element-396">
            {users.map(user => <TableRow key={user.id} data-id="element-397">
                <TableCell data-id="element-398">
                  <div className="flex items-center gap-3" data-id="element-399">
                    <Avatar className="h-8 w-8" data-id="element-400">
                      <AvatarFallback className="bg-primary/10 text-primary text-xs" data-id="element-401">
                        {user.full_name.split(' ').map(n => n[0]).join('')}
                      </AvatarFallback>
                    </Avatar>
                    <span className="font-medium" data-id="element-402">{user.full_name}</span>
                  </div>
                </TableCell>
                <TableCell data-id="element-403">{user.email}</TableCell>
                <TableCell data-id="element-404">
                  <Select value={user.role} onValueChange={val => handleRoleChange(user.id, val as Role)} disabled={user.id === auth.user?.id} // Prevent changing own role
              data-id="element-405">
                    <SelectTrigger className="w-[140px] h-8" data-id="element-406">
                      <SelectValue data-id="element-407" />
                    </SelectTrigger>
                    <SelectContent data-id="element-408">
                      <SelectItem value="Admin" data-id="element-409">Admin</SelectItem>
                      <SelectItem value="Office" data-id="element-410">Pisarna</SelectItem>
                      <SelectItem value="Technician" data-id="element-411">Tehnik</SelectItem>
                    </SelectContent>
                  </Select>
                </TableCell>
                <TableCell data-id="element-412">
                  <div className="flex items-center gap-2" data-id="element-413">
                    {user.sso_provider === 'Microsoft' ? <svg className="w-4 h-4" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" data-id="element-414">
                        <path d="M10 0H0V10H10V0Z" fill="#F25022" data-id="element-415" />
                        <path d="M21 0H11V10H21V0Z" fill="#7FBA00" data-id="element-416" />
                        <path d="M10 11H0V21H10V11Z" fill="#00A4EF" data-id="element-417" />
                        <path d="M21 11H11V21H21V11Z" fill="#FFB900" data-id="element-418" />
                      </svg> : <svg className="w-4 h-4" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-419">
                        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-420" />
                        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-421" />
                        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-422" />
                        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-423" />
                      </svg>}
                    <span className="text-sm" data-id="element-424">{user.sso_provider}</span>
                  </div>
                </TableCell>
                <TableCell data-id="element-425">
                  <div className="flex items-center gap-2" data-id="element-426">
                    <Switch checked={user.is_active} onCheckedChange={val => handleStatusChange(user.id, val)} disabled={user.id === auth.user?.id} // Prevent deactivating self
                data-id="element-427" />
                    <span className="text-sm text-slate-600" data-id="element-428">
                      {user.is_active ? 'Aktiviran' : 'Deaktiviran'}
                    </span>
                  </div>
                </TableCell>
              </TableRow>)}
          </TableBody>
        </Table>
      </div>
    </div>;
}